export default __webpack_public_path__ + "static/media/8.e54f3f49.jpg";